import { baseURL } from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';

export const login = async (data) => {
    const id = toast.loading('Please wait...');
    try {
        const response = await axios({
            method: 'post',
            url: `${baseURL}/api/auth/login`,
            data: data,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (response.data?.success === true) {
            toast.update(id, { render: response.data.message, type: 'success', isLoading: false, autoClose: 3000 });
        } else {
            toast.update(id, { render: response.data.message || 'Login failed', type: 'error', isLoading: false, autoClose: 3000 });
        }
        return response.data;
    } catch (error) {
        if (error.response.status === 500) {
            setTimeout(() => {
                toast.update(id, { render: error.response.data.message || 'Something went wrong !!', type: 'error', isLoading: false, autoClose: 3000 });
            }, 100);
        } else if (error.response.status === 400) {
            setTimeout(() => {
                toast.update(id, { render: error?.response?.data?.message || 'Something went wrong !!', type: 'error', isLoading: false, autoClose: 3000 });
            }, 100);
        } else {
            setTimeout(() => {
                toast.update(id, { render: error.response.data.message || 'Something went wrong !!', type: 'warn', isLoading: false, autoClose: 3000 });
            }, 100);
        }
        return error.response;
    }
};

export const refreshToken = async (data) => {
    const obj = {
        refreshToken: data
    };
    let res;
    await axios({
        method: 'post',
        url: `${baseURL}/api/Auth/refresh`,
        data: obj,
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            sessionStorage.setItem('token', response?.data?.data?.token);
            sessionStorage.setItem('refreshToken', response?.data?.data?.refreshToken);
            window.location.href = '/';
            return response.data;
        })
        .catch((err) => {
            res = false;
            // console.err(err);
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = '/';
        });
    return res;
};

export const updatePassword = async (password) => {
    let res;
    await axios({
        method: 'post',
        url: `${baseURL}userManagement/changePassword`,
        data: { password },
        headers: {
            'Content-Type': 'application/json',
            Authorization: sessionStorage.getItem('token')
        }
    })
        .then((response) => {
            toast.success(response.data.data);
            res = response?.data?.data;
        })
        .catch((err) => {
            toast.warn(err?.response?.data?.messages || 'Something went wrong');
            res = false;
        });
    return res;
};
